// This file is auto-generated by @hey-api/openapi-ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { $OpenApiTs } from './models';

@Injectable({
    providedIn: 'root',
})
export class NutzerCommonControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Find current Nutzer
     * @returns NutzerDto Nutzer was returned
     * @throws ApiError
     */
    public findCurrentNutzer(): Observable<$OpenApiTs['/user/v1/nutzer/current']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/user/v1/nutzer/current',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a Nutzer
     * @returns NutzerDto Nutzer was updated and returned
     * @throws ApiError
     */
    public updateNutzer(
        data: $OpenApiTs['/user/v1/nutzer/current']['put']['req'],
    ): Observable<$OpenApiTs['/user/v1/nutzer/current']['put']['res'][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/user/v1/nutzer/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class UnternehmenszuordnungUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update an Unternehmenszuordnung
     * @returns UnternehmenszuordnungDto Unternehmenszuordnung was updated and returned
     * @throws ApiError
     */
    public updateUnternehmenszuordnung(
        data: $OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen']['put']['req'],
    ): Observable<$OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen']['put']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create an Unternehmenszuordnung
     * @returns boolean Unternehmenszuordnung was created
     * @throws ApiError
     */
    public createUnternehmenszuordnung(
        data: $OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen']['post']['req'],
    ): Observable<$OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen']['post']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete an Unternehmenszuordnung
     * @returns boolean Unternehmenszuordnung was deleted
     * @throws ApiError
     */
    public removeUnternehmenszuordnung(
        data: $OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen/nutzer/{nutzerIdpId}']['delete']['req'],
    ): Observable<$OpenApiTs['/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen/nutzer/{nutzerIdpId}']['delete']['res'][200]> {
        const { unternehmenId, nutzerIdpId } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NutzerFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update roles of a Nutzer
     * @returns NutzerDto Nutzer was updated and returned
     * @throws ApiError
     */
    public updateRoles(
        data: $OpenApiTs['/user/ffa/v1/nutzer/{nutzerIdpId}/roles']['put']['req'],
    ): Observable<$OpenApiTs['/user/ffa/v1/nutzer/{nutzerIdpId}/roles']['put']['res'][200]> {
        const { nutzerIdpId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/user/ffa/v1/nutzer/{nutzerIdpId}/roles',
            path: {
                nutzerIdpId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Reset password of a Nutzer
     * @returns boolean Password was reset
     * @throws ApiError
     */
    public resetUserPassword(
        data: $OpenApiTs['/user/ffa/v1/nutzer/{nutzerIdpId}/password/reset']['put']['req'],
    ): Observable<$OpenApiTs['/user/ffa/v1/nutzer/{nutzerIdpId}/password/reset']['put']['res'][200]> {
        const { nutzerIdpId } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/user/ffa/v1/nutzer/{nutzerIdpId}/password/reset',
            path: {
                nutzerIdpId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get page of Nutzer of FFA
     * @returns PaginatedResponseNutzerAdminResponseDto Page of Nutzer was returned
     * @throws ApiError
     */
    public getNutzerOfFfa(
        data: $OpenApiTs['/user/ffa/v1/nutzer']['get']['req'] = {},
    ): Observable<$OpenApiTs['/user/ffa/v1/nutzer']['get']['res'][200]> {
        const { searchparameter, rollen, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/user/ffa/v1/nutzer',
            query: {
                searchparameter,
                rollen,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a Nutzer
     * @returns NutzerDto Nutzer was created and returned
     * @throws ApiError
     */
    public createNutzer(data: $OpenApiTs['/user/ffa/v1/nutzer']['post']['req']): Observable<$OpenApiTs['/user/ffa/v1/nutzer']['post']['res'][201]> {
        const { requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/user/ffa/v1/nutzer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a Nutzer by IdP ID
     * @returns boolean Nutzer was deleted
     * @throws ApiError
     */
    public deleteNutzerByIdpId(
        data: $OpenApiTs['/user/ffa/v1/nutzer/{idpId}']['delete']['req'],
    ): Observable<$OpenApiTs['/user/ffa/v1/nutzer/{idpId}']['delete']['res'][200]> {
        const { idpId } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/user/ffa/v1/nutzer/{idpId}',
            path: {
                idpId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class AntragUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update Antragsstatus for Einreichung
     * @returns any Antragsstatus for Antrag was updated
     * @throws ApiError
     */
    public updateAntragsStatusForEinreichung(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}']['put']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}']['put']['res'][200]> {
        const { antragId, unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}',
            path: {
                antragId,
                unternehmenId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update Antragsstatus for deletion
     * @returns any Antragsstatus for Antrag was updated
     * @throws ApiError
     */
    public updateAntragsStatusForDeletion(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}']['delete']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}']['delete']['res'][200]> {
        const { antragId, unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}',
            path: {
                antragId,
                unternehmenId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class PostkorbNachrichtUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update Gelesenstatus of Postkorbnachricht
     * @returns boolean Gelesenstatus of Postkorbnachricht was updated
     * @throws ApiError
     */
    public updateGelesenStatus(
        data: $OpenApiTs['/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}']['put']['req'],
    ): Observable<$OpenApiTs['/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}']['put']['res'][200]> {
        const { unternehmenId, postkorbNachrichtId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}',
            path: {
                unternehmenId,
                postkorbNachrichtId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Page of Postkorbnachricht for the current Nutzer
     * @returns PaginatedResponsePostkorbNachrichtDto Page of Postkorbnachricht was returned
     * @throws ApiError
     */
    public getPostkorbNachricht(
        data: $OpenApiTs['/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten']['get']['req'],
    ): Observable<$OpenApiTs['/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten']['get']['res'][200]> {
        const { unternehmenId, searchparameter, onlyShowAllgemeineNachrichten, hideAllgemeineNachrichten, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten',
            path: {
                unternehmenId,
            },
            query: {
                searchparameter,
                onlyShowAllgemeineNachrichten,
                hideAllgemeineNachrichten,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class PostkorbNachrichtCommonControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update Gelesenstatus of Postkorbnachricht
     * @returns boolean Gelesenstatus of Postkorbnachricht was updated
     * @throws ApiError
     */
    public updateGelesenStatus1(
        data: $OpenApiTs['/inbox/common/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}']['put']['req'],
    ): Observable<$OpenApiTs['/inbox/common/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}']['put']['res'][200]> {
        const { postkorbNachrichtId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/inbox/common/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}',
            path: {
                postkorbNachrichtId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Page of allgemeine Postkorbnachricht for the current Nutzer
     * @returns PaginatedResponsePostkorbNachrichtDto Page of Postkorbnachricht was returned
     * @throws ApiError
     */
    public getPostkorbNachrichten(
        data: $OpenApiTs['/inbox/common/v1/postkorbnachrichten']['get']['req'] = {},
    ): Observable<$OpenApiTs['/inbox/common/v1/postkorbnachrichten']['get']['res'][200]> {
        const { searchparameter, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/inbox/common/v1/postkorbnachrichten',
            query: {
                searchparameter,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class RegistrationControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Confirm the registration of a user
     * @returns boolean Nutzer registration was confirmed
     * @throws ApiError
     */
    public confirmRegistration(
        data: $OpenApiTs['/user/common/v1/registration/confirm']['post']['req'],
    ): Observable<$OpenApiTs['/user/common/v1/registration/confirm']['post']['res'][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/user/common/v1/registration/confirm',
            body: requestBody,
            mediaType: 'text/plain',
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NebenantragUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Create a new Nebenantrag and return its Antragsnummer
     * @returns AntragsnummerDto Successfully created new Nebenantrag
     * @throws ApiError
     */
    public createNebenantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantraege']['post']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantraege']['post']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/unternehmen/{unternehmenId}/v1/nebenantraege',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of Nebenanträge created for a given Förderantrag
     * @returns PaginatedResponseNebenantragDto list of Nebenanträge was returned
     * @throws ApiError
     */
    public findNebenantragReferencingFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantraege/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantraege/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { unternehmenId, foerderantragId, nebenantragsartId, searchparameter, status, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/nebenantraege/foerderantrag/{foerderantragId}',
            path: {
                unternehmenId,
                foerderantragId,
            },
            query: {
                nebenantragsartId,
                searchparameter,
                status,
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderantragUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a Page of Förderantrag for the current Nutzer
     * @returns PaginatedResponseFoerderantragDto Page of Förderantrag was returned
     * @throws ApiError
     */
    public findFoerderantraegeForCurrentNutzer(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege']['get']['res'][200]> {
        const { unternehmenId, searchparameter, foerderart, status, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderantraege',
            path: {
                unternehmenId,
            },
            query: {
                searchparameter,
                foerderart,
                status,
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Foerderantrag and return its Antragsnummer
     * @returns AntragsnummerDto Successfully created new Foerderantrag
     * @throws ApiError
     */
    public createFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege']['post']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege']['post']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderantraege',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Förderantrag by ID
     * @returns FoerderantragDto Förderantrag was returned
     * @throws ApiError
     */
    public findFoerderantragById(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege/{id}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege/{id}']['get']['res'][200]> {
        const { unternehmenId, id } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderantraege/{id}',
            path: {
                unternehmenId,
                id,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve editable funding applications for a user within a specified company
     * @returns FoerderantragDto Successfully retrieved the list of editable funding applications
     * @throws ApiError
     */
    public getFoerderantrageForNutzerInUnternehmen(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege/nutzer/{nutzerIdpId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderantraege/nutzer/{nutzerIdpId}']['get']['res'][200]> {
        const { nutzerIdpId, unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderantraege/nutzer/{nutzerIdpId}',
            path: {
                nutzerIdpId,
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class BearbeiterUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Make Nutzer a Bearbeiter for Förderanträge
     * @returns BearbeiterDto List of Bearbeiter was returned
     * @throws ApiError
     */
    public makeNutzerBearbeiter(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter']['post']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter']['post']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/unternehmen/{unternehmenId}/v1/bearbeiter',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Make given Nutzer Bearbeiter for a given Foerderanträge
     * @returns boolean Bearbeiter were created
     * @throws ApiError
     */
    public createBearbeiterForFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds']['post']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds']['post']['res'][201]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete multiple Bearbeiter for a given Foerderantrag
     * @returns boolean Bearbeitungsrechte were deleted for list of Nutzer
     * @throws ApiError
     */
    public deleteBearbeiterForFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds']['delete']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds']['delete']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of Bearbeiter for one given Foerderantrag
     * @returns NutzerDto List of Bearbeiter was returned
     * @throws ApiError
     */
    public getAllBearbeiterForOneFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { unternehmenId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/bearbeiter/foerderantrag/{foerderantragId}',
            path: {
                unternehmenId,
                foerderantragId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Remove Nutzer as Bearbeiter for Förderanträge
     * @returns boolean all of the Bearbeiter were deleted
     * @throws ApiError
     */
    public removeNutzerAsBearbeiter(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/{nutzerIdpId}']['delete']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/bearbeiter/{nutzerIdpId}']['delete']['res'][200]> {
        const { unternehmenId, nutzerIdpId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/process/unternehmen/{unternehmenId}/v1/bearbeiter/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class BeantragungserlaubnisUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Create Beantragungserlaubnisse for given Nutzer, Unternehmen and Förderbereiche
     * @returns boolean Beantragungserlaubnisse were created
     * @throws ApiError
     */
    public createBeantragungserlaubnisse(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['post']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['post']['res'][201]> {
        const { unternehmenId, nutzerIdpId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete Beantragungserlaubnisse for given Nutzer, Unternehmen and Förderbereiche
     * @returns boolean Beantragungserlaubnisse were deleted
     * @throws ApiError
     */
    public deleteBeantragungserlaubnisse(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['delete']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['delete']['res'][200]> {
        const { unternehmenId, nutzerIdpId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class BeantragungserlaubnisFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Create Beantragungserlaubnisse for given Nutzer, Unternehmen and Förderbereiche
     * @returns boolean Beantragungserlaubnisse were created
     * @throws ApiError
     */
    public createBeantragungserlaubnisse1(
        data: $OpenApiTs['/process/ffa/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}']['post']['res'][201]> {
        const { unternehmenId, nutzerIdpId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class StammdatenFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Update Stammdaten
     * @returns any Stammdaten were updated
     * @throws ApiError
     */
    public updateStammdaten(
        data: $OpenApiTs['/process/ffa/v1/stammdaten/update']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/stammdaten/update']['post']['res'][200]> {
        const { separator, formData } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/stammdaten/update',
            query: {
                separator,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class MaintenanceFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Set maintenance time
     * @returns any Successfully set up maintenance time
     * @throws ApiError
     */
    public setMaintenance(
        data: $OpenApiTs['/process/ffa/v1/maintenance']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/maintenance']['post']['res'][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/maintenance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Stop maintenance
     * @returns any Successfully stopped maintenance
     * @throws ApiError
     */
    public stopMaintenance(): Observable<$OpenApiTs['/process/ffa/v1/maintenance/stop']['delete']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/process/ffa/v1/maintenance/stop',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class BroadcastFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Send Broadcast Nachricht
     * @returns boolean Broadcast Nachricht was sent
     * @throws ApiError
     */
    public sendBroadcastNachrichten(
        data: $OpenApiTs['/process/ffa/v1/broadcast']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/broadcast']['post']['res'][200]> {
        const { requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/broadcast',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Send new Nutzungsbedingungen
     * @returns boolean New Nutzungsbedingungen were sent
     * @throws ApiError
     */
    public sendNewNutzungsbedingungen(): Observable<$OpenApiTs['/process/ffa/v1/broadcast/nutzungsbedingungen']['post']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/broadcast/nutzungsbedingungen',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Send new Datenschutzbedingungen
     * @returns boolean New Datenschutzbedingungen were sent
     * @throws ApiError
     */
    public sendNewDatenschutzbedingungen(): Observable<$OpenApiTs['/process/ffa/v1/broadcast/datenschutzbedingungen']['post']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/broadcast/datenschutzbedingungen',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class BearbeiterFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Make Nutzer a Bearbeiter for Förderanträge
     * @returns BearbeiterDto List of Bearbeiter was returned
     * @throws ApiError
     */
    public makeNutzerBearbeiter1(
        data: $OpenApiTs['/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}']['post']['res'][200]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Make multiple given Nutzer Bearbeiter for one given Foerderantrag
     * @returns boolean Bearbeitungsrechte were created
     * @throws ApiError
     */
    public createBearbeiterForFoerderantrag1(
        data: $OpenApiTs['/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}/withMultipleNutzerIdpIds']['post']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}/withMultipleNutzerIdpIds']['post']['res'][201]> {
        const { unternehmenId, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}/withMultipleNutzerIdpIds',
            path: {
                unternehmenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of Nutzer who are Bearbeiter for one given Foerderantrag
     * @returns NutzerDto List of Bearbeiter was returned
     * @throws ApiError
     */
    public getAllBearbeiterForFoerderantrag(
        data: $OpenApiTs['/process/ffa/v1/bearbeiter/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/bearbeiter/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/bearbeiter/foerderantrag/{foerderantragId}',
            path: {
                foerderantragId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderantragCommonControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Create a new Foerderantrag for Unternehmensregistrierung and return its Antragsnummer
     * @returns AntragsnummerDto Successfully created new Foerderantrag for a new Unternehmensregistrierung
     * @throws ApiError
     */
    public createFoerderantragForUnternehmensregistrierung(): Observable<$OpenApiTs['/process/common/v1/foerderantraege']['post']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/common/v1/foerderantraege',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update the Unternehmensname after Unternehmensregistrierung
     * @returns boolean Successfully updated the Unternehmensname after Unternehmensregistrierung
     * @throws ApiError
     */
    public updateUnternehmensnameAfterUnternehmensRegistrierung(
        data: $OpenApiTs['/process/common/v1/foerderantraege/{antragsnummer}/update-unternehmensname']['post']['req'],
    ): Observable<$OpenApiTs['/process/common/v1/foerderantraege/{antragsnummer}/update-unternehmensname']['post']['res'][200]> {
        const { antragsnummer, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/process/common/v1/foerderantraege/{antragsnummer}/update-unternehmensname',
            path: {
                antragsnummer,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class DokumenteNscaleControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Confirm Retrieval of an Antrag by nscale
     * @returns any Abholung confirmed
     * @throws ApiError
     */
    public confirmAntragsabholung(
        data: $OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/confirm-abholung']['post']['req'],
    ): Observable<$OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/confirm-abholung']['post']['res'][200]> {
        const { antragsnummer, requestBody } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/confirm-abholung',
            path: {
                antragsnummer,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get XML, PDF and JSON of an Antrag by Antragsnummer
     * @returns AntragsDokumentDto DTOs containing the documents were returned
     * @throws ApiError
     */
    public getAntragDokumente(
        data: $OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}']['get']['req'],
    ): Observable<$OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}']['get']['res'][200]> {
        const { antragsnummer } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}',
            path: {
                antragsnummer,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Mapping for attachments of an Antrag by Antragsnummer
     * @returns DokumentMappingDto Mapping was returned
     * @throws ApiError
     */
    public getAntragAttachmentMapping(
        data: $OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/attachmentmapping']['get']['req'],
    ): Observable<$OpenApiTs['/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/attachmentmapping']['get']['res'][200]> {
        const { antragsnummer } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/attachmentmapping',
            path: {
                antragsnummer,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of Antraege with Status Abholbereit
     * @returns AntragDto List of Antraege was returned
     * @throws ApiError
     */
    public getAbholbereiteAntraege(
        data: $OpenApiTs['/ext/process/nscale/v1/dokumente/antraege']['get']['req'] = {},
    ): Observable<$OpenApiTs['/ext/process/nscale/v1/dokumente/antraege']['get']['res'][200]> {
        const { shortname } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/ext/process/nscale/v1/dokumente/antraege',
            query: {
                shortname,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class LoggingCommonControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Log a message
     * @returns boolean Message was logged
     * @throws ApiError
     */
    public createLogEntry(
        data: $OpenApiTs['/application/common/v1/logging']['post']['req'],
    ): Observable<$OpenApiTs['/application/common/v1/logging']['post']['res'][200]> {
        const { message, level } = data;
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/application/common/v1/logging',
            query: {
                message,
                level,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NutzerUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get page of Nutzer of Unternehmen
     * @returns PaginatedResponseNutzerAdminResponseDto Page of Nutzer was returned
     * @throws ApiError
     */
    public getNutzerOfUnternehmen(
        data: $OpenApiTs['/user/unternehmen/{unternehmenId}/v1/nutzer']['get']['req'],
    ): Observable<$OpenApiTs['/user/unternehmen/{unternehmenId}/v1/nutzer']['get']['res'][200]> {
        const { unternehmenId, searchparameter, aktiv, rollen, foerderbereiche, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/user/unternehmen/{unternehmenId}/v1/nutzer',
            path: {
                unternehmenId,
            },
            query: {
                searchparameter,
                aktiv,
                rollen,
                foerderbereiche,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class UnternehmenszuordnungCommonControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get list of active Unternehmenszuordnungen for Nutzer
     * @returns UnternehmenszuordnungDto List of active Unternehmenszuordnungen was returned
     * @throws ApiError
     */
    public getAktiveUnternehmenszuordnungenForNutzer(): Observable<$OpenApiTs['/user/common/v1/unternehmenszuordnungen']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/user/common/v1/unternehmenszuordnungen',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class UnternehmenUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get an Unternehmen and its relations by ID
     * @returns UnternehmenWithRelationsDto Unternehmen was returned
     * @throws ApiError
     */
    public findUnternehmenWithRelations(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/unternehmen/withRelations']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/unternehmen/withRelations']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/unternehmen/withRelations',
            path: {
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NebenantragsartUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a list of Nebenantragsart which are allowed to be created for a given Förderantrag
     * @returns NebenantragsartDto list of Nebenantragsart was returned
     * @throws ApiError
     */
    public findPermittedNebenantragsart(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/permitted/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/permitted/{foerderantragId}']['get']['res'][200]> {
        const { unternehmenId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/permitted/{foerderantragId}',
            path: {
                unternehmenId,
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of information and amount of Nebenantragsart created for a given Förderantrag
     * @returns NebenantragsartCountDto list of name and amount of Nebenantragsart was returned
     * @throws ApiError
     */
    public findNebenantragsartCountDto(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/count/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/count/{foerderantragId}']['get']['res'][200]> {
        const { unternehmenId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/count/{foerderantragId}',
            path: {
                unternehmenId,
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class HistorieUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a Page of Historieneinträge for a Förderantrag
     * @returns PaginatedResponseHistorieDto Page of Historieneinträge was returned
     * @throws ApiError
     */
    public getHistorieneintraegeForFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/historien/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/historien/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId, unternehmenId, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/historien/foerderantrag/{foerderantragId}',
            path: {
                foerderantragId,
                unternehmenId,
            },
            query: {
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderbereichUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a List of Förderbereiche for which the current user can create Anträge for a given Unternehmen
     * @returns FoerderbereichDto List of Förderbereiche was returned
     * @throws ApiError
     */
    public findFoerderbereicheForCurrentNutzerAndUnternehmen(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderbereiche',
            path: {
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of Förderbereiche for which the user can create Anträge for a given Unternehmen
     * @returns FoerderbereichDto List of Förderbereiche was returned
     * @throws ApiError
     */
    public findFoerderbereicheForNutzerAndUnternehmen(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche/nutzer/{nutzerIdpId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche/nutzer/{nutzerIdpId}']['get']['res'][200]> {
        const { unternehmenId, nutzerIdpId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderbereiche/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List active Förderbereiche
     * @returns FoerderbereichDto List of Förderbereiche was returned
     * @throws ApiError
     */
    public findAllActiveFoerderbereiche(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche/active']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderbereiche/active']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderbereiche/active',
            path: {
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderartUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a List of active Förderarten for which the current user has Foerderantraege of which they are a Bearbeiter
     * @returns FoerderartDto List of active Förderarten was returned
     * @throws ApiError
     */
    public findFoerderartenOfFoerderantraegeForCurrentNutzer(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderarten/bearbeiter']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderarten/bearbeiter']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderarten/bearbeiter',
            path: {
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of active Förderarten the current user could create Anträge for
     * @returns FoerderartDto List of active Förderarten was returned
     * @throws ApiError
     */
    public findActiveFoerderartenForCurrentNutzer(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderarten/active']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/foerderarten/active']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/foerderarten/active',
            path: {
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class DokumenteUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * get Content of Dokument with dokument ID
     * @returns DokumentContentDto Document was returned
     * @throws ApiError
     */
    public getDokumentContent(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/{dokumentId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/{dokumentId}']['get']['res'][200]> {
        const { dokumentId, unternehmenId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/{dokumentId}',
            path: {
                dokumentId,
                unternehmenId,
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * get PDF of an Antrag
     * @returns AntragsDokumentDto Document was returned
     * @throws ApiError
     */
    public getPdfDokumentOfAntrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/pdf']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/pdf']['get']['res'][200]> {
        const { unternehmenId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/pdf',
            path: {
                unternehmenId,
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Mark a Dokument as gelesen
     * @returns any Dokument was marked as gelesen
     * @throws ApiError
     */
    public markDokumentAsGelesen(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{dokumentId}/lesebestaetigung']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/{dokumentId}/lesebestaetigung']['get']['res'][200]> {
        const { dokumentId, unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/dokumente/{dokumentId}/lesebestaetigung',
            path: {
                dokumentId,
                unternehmenId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of required Lesebestaetigungen
     * @returns RequiredLesebestaetigungDto List of required Lesebestaetigungen
     * @throws ApiError
     */
    public getRequiredLesebestaetigungen(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/requiredLesebestaetigungen']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/requiredLesebestaetigungen']['get']['res'][200]> {
        const { unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/dokumente/requiredLesebestaetigungen',
            path: {
                unternehmenId,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Page of FFA documents for a Foerderantrag
     * @returns PaginatedResponseFfaDokumentDto List of FFA documents
     * @throws ApiError
     */
    public getFfaDokumenteForFoerderantrag(
        data: $OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/ffa/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/unternehmen/{unternehmenId}/v1/dokumente/ffa/{foerderantragId}']['get']['res'][200]> {
        const { unternehmenId, foerderantragId, searchparameter, onlyBescheide, onlyUngeleseneBescheide, noBescheide, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/unternehmen/{unternehmenId}/v1/dokumente/ffa/{foerderantragId}',
            path: {
                unternehmenId,
                foerderantragId,
            },
            query: {
                searchparameter,
                onlyBescheide,
                onlyUngeleseneBescheide,
                noBescheide,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class UnternehmenFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get all unternehmen matching the search criteria
     * @returns UnternehmenSelectionDto List of Unternehmen was returned
     * @throws ApiError
     */
    public findUnternehmen(
        data: $OpenApiTs['/process/ffa/v1/unternehmen']['get']['req'] = {},
    ): Observable<$OpenApiTs['/process/ffa/v1/unternehmen']['get']['res'][200]> {
        const { searchparameter } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/unternehmen',
            query: {
                searchparameter,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NebenantragsartFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a list of Nebenantragsart which are allowed to be created for a given Förderantrag
     * @returns NebenantragsartDto list of Nebenantragsart was returned
     * @throws ApiError
     */
    public findPermittedNebenantragsart1(
        data: $OpenApiTs['/process/ffa/v1/nebenantragsarten/permitted/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/nebenantragsarten/permitted/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/nebenantragsarten/permitted/{foerderantragId}',
            path: {
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a list of information and amount of Nebenantragsart created for a given Förderantrag
     * @returns NebenantragsartCountDto list of name and amount of Nebenantragsart was returned
     * @throws ApiError
     */
    public findNebenantragsartCountDto1(
        data: $OpenApiTs['/process/ffa/v1/nebenantragsarten/count/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/nebenantragsarten/count/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/nebenantragsarten/count/{foerderantragId}',
            path: {
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class NebenantragFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a list of Nebenanträge created for a given Förderantrag
     * @returns PaginatedResponseNebenantragDto list of Nebenanträge was returned
     * @throws ApiError
     */
    public findNebenantragReferencingFoerderantrag1(
        data: $OpenApiTs['/process/ffa/v1/nebenantraege/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/nebenantraege/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId, nebenantragsartId, searchparameter, status, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/nebenantraege/foerderantrag/{foerderantragId}',
            path: {
                foerderantragId,
            },
            query: {
                nebenantragsartId,
                searchparameter,
                status,
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class HistorieFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a Page of Historieneinträge for a Förderantrag
     * @returns PaginatedResponseHistorieDto Page of Historieneinträge was returned
     * @throws ApiError
     */
    public getHistorieneintraegeForFoerderantrag1(
        data: $OpenApiTs['/process/ffa/v1/historien/foerderantrag/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/historien/foerderantrag/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/historien/foerderantrag/{foerderantragId}',
            path: {
                foerderantragId,
            },
            query: {
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderbereichFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a List of all Förderbereiche
     * @returns FoerderbereichDto List of Förderbereiche was returned
     * @throws ApiError
     */
    public findAll(): Observable<$OpenApiTs['/process/ffa/v1/foerderbereiche']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/foerderbereiche',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a List of Förderbereiche for which the user can create Anträge for a given Unternehmen
     * @returns FoerderbereichDto List of Förderbereiche was returned
     * @throws ApiError
     */
    public findFoerderbereicheForNutzerAndUnternehmen1(
        data: $OpenApiTs['/process/ffa/v1/foerderbereiche/{unternehmenId}/nutzer/{nutzerIdpId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/foerderbereiche/{unternehmenId}/nutzer/{nutzerIdpId}']['get']['res'][200]> {
        const { unternehmenId, nutzerIdpId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/foerderbereiche/{unternehmenId}/nutzer/{nutzerIdpId}',
            path: {
                unternehmenId,
                nutzerIdpId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FoerderantragFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get a Page of Förderantrag
     * @returns PaginatedResponseFoerderantragDto Page of Förderantrag was returned
     * @throws ApiError
     */
    public findAllWithParams(
        data: $OpenApiTs['/process/ffa/v1/foerderantraege']['get']['req'] = {},
    ): Observable<$OpenApiTs['/process/ffa/v1/foerderantraege']['get']['res'][200]> {
        const { searchparameter, foerderart, status, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/foerderantraege',
            query: {
                searchparameter,
                foerderart,
                status,
                page,
                size,
                sort,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Förderantrag by ID
     * @returns FoerderantragDto Förderantrag was returned
     * @throws ApiError
     */
    public findFoerderantragById1(
        data: $OpenApiTs['/process/ffa/v1/foerderantraege/{id}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/foerderantraege/{id}']['get']['res'][200]> {
        const { id } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/foerderantraege/{id}',
            path: {
                id,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve editable funding applications for a user within a specified company
     * @returns FoerderantragDto Successfully retrieved the list of editable funding applications
     * @throws ApiError
     */
    public getFoerderantrageForNutzerInUnternehmen1(
        data: $OpenApiTs['/process/ffa/v1/foerderantraege/unternehmen/{unternehmenId}/nutzer/{nutzerIdpId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/foerderantraege/unternehmen/{unternehmenId}/nutzer/{nutzerIdpId}']['get']['res'][200]> {
        const { nutzerIdpId, unternehmenId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/foerderantraege/unternehmen/{unternehmenId}/nutzer/{nutzerIdpId}',
            path: {
                nutzerIdpId,
                unternehmenId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class DokumenteFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * get Content of Dokument with dokument ID
     * @returns DokumentContentDto Document was returned
     * @throws ApiError
     */
    public getDokumentContent1(
        data: $OpenApiTs['/process/ffa/v1/dokumente/{foerderantragId}/{dokumentId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/dokumente/{foerderantragId}/{dokumentId}']['get']['res'][200]> {
        const { dokumentId, foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/dokumente/{foerderantragId}/{dokumentId}',
            path: {
                dokumentId,
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * get PDF of an Antrag
     * @returns AntragsDokumentDto Document was returned
     * @throws ApiError
     */
    public getPdfDokumentOfAntrag1(
        data: $OpenApiTs['/process/ffa/v1/dokumente/{foerderantragId}/pdf']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/dokumente/{foerderantragId}/pdf']['get']['res'][200]> {
        const { foerderantragId } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/dokumente/{foerderantragId}/pdf',
            path: {
                foerderantragId,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a Page of FFA documents for a Foerderantrag
     * @returns PaginatedResponseFfaDokumentDto List of FFA documents
     * @throws ApiError
     */
    public getFfaDokumenteForFoerderantrag1(
        data: $OpenApiTs['/process/ffa/v1/dokumente/ffa/{foerderantragId}']['get']['req'],
    ): Observable<$OpenApiTs['/process/ffa/v1/dokumente/ffa/{foerderantragId}']['get']['res'][200]> {
        const { foerderantragId, searchparameter, onlyBescheide, onlyUngeleseneBescheide, noBescheide, page, size, sort } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/ffa/v1/dokumente/ffa/{foerderantragId}',
            path: {
                foerderantragId,
            },
            query: {
                searchparameter,
                onlyBescheide,
                onlyUngeleseneBescheide,
                noBescheide,
                page,
                size,
                sort,
            },
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class RechtlicheInformationenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Retrieves the Vollmacht Formular file
     * @returns FileContentDto Vollmacht Formular file was retrieved successfully
     * @throws ApiError
     */
    public getVollmachtFormularFile(): Observable<$OpenApiTs['/process/common/v1/rechtliches/vollmachtFormular']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/vollmachtFormular',
        });
    }

    /**
     * Retrieves the Nutzungsbedingungen file
     * @returns FileContentDto Nutzungsbedingungen file was retrieved successfully
     * @throws ApiError
     */
    public getNutzungsbedingungenFile(): Observable<$OpenApiTs['/process/common/v1/rechtliches/nutzungsbedingungen']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/nutzungsbedingungen',
        });
    }

    /**
     * Retrieves the datenschutz file as Resource for download
     * @returns binary Datenschutz file was retrieved successfully
     * @throws ApiError
     */
    public getNutzungsbedingungenFileForDownload(): Observable<
        $OpenApiTs['/process/common/v1/rechtliches/nutzungsbedingungen/download']['get']['res'][200]
    > {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/nutzungsbedingungen/download',
        });
    }

    /**
     * Retrieves the imprint template
     * @returns RenderedTemplateDto Impressum template was retrieved successfully
     * @throws ApiError
     */
    public getImpressumTemplate(): Observable<$OpenApiTs['/process/common/v1/rechtliches/impressum']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/impressum',
        });
    }

    /**
     * Retrieves the Faq file
     * @returns FileContentDto FAQ file was retrieved successfully
     * @throws ApiError
     */
    public getFaqFile(): Observable<$OpenApiTs['/process/common/v1/rechtliches/faq']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/faq',
        });
    }

    /**
     * Retrieves the datenschutz file
     * @returns FileContentDto Datenschutz file was retrieved successfully
     * @throws ApiError
     */
    public getDatenschutzFile(): Observable<$OpenApiTs['/process/common/v1/rechtliches/datenschutz']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/datenschutz',
        });
    }

    /**
     * Retrieves the datenschutz file as Resource for download
     * @returns binary Datenschutz file was retrieved successfully
     * @throws ApiError
     */
    public getDatenschutzFileForDownload(): Observable<$OpenApiTs['/process/common/v1/rechtliches/datenschutz/download']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/rechtliches/datenschutz/download',
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class MaintenanceControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Return Maintenance time
     * @returns MaintenanceDto Successfully returned maintenance time
     * @throws ApiError
     */
    public getMaintenance(): Observable<$OpenApiTs['/process/common/v1/maintenance']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/process/common/v1/maintenance',
            errors: {
                400: `Request was invalid`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class FormularUnternehmenControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Get form content as JSON by antragsnummer
     * @returns FormContentDto FormContent was returned
     * @throws ApiError
     */
    public getFormContentByAntragsnummer(
        data: $OpenApiTs['/form/unternehmen/{unternehmenId}/v1/formulare/{antragsnummer}']['get']['req'],
    ): Observable<$OpenApiTs['/form/unternehmen/{unternehmenId}/v1/formulare/{antragsnummer}']['get']['res'][200]> {
        const { unternehmenId, antragsnummer, onlyStammdaten } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/form/unternehmen/{unternehmenId}/v1/formulare/{antragsnummer}',
            path: {
                unternehmenId,
                antragsnummer,
            },
            query: {
                onlyStammdaten,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                404: `Entity was not found`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class AntragNscaleControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Check for a list of nscale objectIds of Platzhalterantraege whether they where transferred
     * @returns PlatzhalterantragStatusDto List of nscale objectIds of Platzhalterantraege and whether they where transferred was returned
     * @throws ApiError
     */
    public checkPlatzhalterantraege(
        data: $OpenApiTs['/ext/process/nscale/v1/antraege/platzhalter']['get']['req'],
    ): Observable<$OpenApiTs['/ext/process/nscale/v1/antraege/platzhalter']['get']['res'][200]> {
        const { nscaleObjectIds } = data;
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/ext/process/nscale/v1/antraege/platzhalter',
            query: {
                nscaleObjectIds,
            },
            errors: {
                400: `Request was invalid`,
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class JobFfaControllerService {
    constructor(public readonly http: HttpClient) {}

    /**
     * Execute Stammdaten job
     * @returns any Stammdaten job was started
     * @throws ApiError
     */
    public executeStammdatenJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/stammdaten']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/stammdaten',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute Nscale job
     * @returns any Nscale job was started
     * @throws ApiError
     */
    public executeNscaleJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/nscale']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/nscale',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute Monitor job
     * @returns any Monitor job was started
     * @throws ApiError
     */
    public executeMonitorJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/monitor']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/monitor',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute Mailer job
     * @returns any Mailer job was started
     * @throws ApiError
     */
    public executeMailerJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/mailer']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/mailer',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute FileTransfer job
     * @returns any FileTransfer job was started
     * @throws ApiError
     */
    public executeFileTransferJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/fileTransfer']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/fileTransfer',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute CleanUp job
     * @returns any CleanUp job was started
     * @throws ApiError
     */
    public executeCleanUpJob(): Observable<$OpenApiTs['/batch/ffa/v1/job/cleanUp']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/cleanUp',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Execute AntragS3 job
     * @returns any AntragS3 job was started
     * @throws ApiError
     */
    public executeAntragS3Job(): Observable<$OpenApiTs['/batch/ffa/v1/job/antragS3']['get']['res'][200]> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/batch/ffa/v1/job/antragS3',
            errors: {
                401: `Unauthorized request`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
}
